import { render, staticRenderFns } from "./FechamentoGeral.vue?vue&type=template&id=0af96460&scoped=true&"
import script from "./FechamentoGeral.vue?vue&type=script&lang=js&"
export * from "./FechamentoGeral.vue?vue&type=script&lang=js&"
import style0 from "./FechamentoGeral.vue?vue&type=style&index=0&id=0af96460&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af96460",
  null
  
)

export default component.exports